import React, { useContext } from 'react';
import DisabledOrPrivateInfo from '../../../../lego/DisabledOrPrivateInfo';
import { CommentEditorContext } from '../../../../../CommentEditor/context';
var CantPostView = function () {
    var _a = useContext(CommentEditorContext), commentableItemId = _a.commentableItemId, commentableType = _a.commentableType;
    return (React.createElement(DisabledOrPrivateInfo, { commentableItemId: commentableItemId, commentableType: commentableType }));
};
CantPostView.displayName = 'CantPostView';
export default CantPostView;
//# sourceMappingURL=CantPostView.js.map